import { Component, ChangeDetectionStrategy } from '@angular/core';

import {Modal} from "@softline/ui-core";

import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'soft-artikelposition-uebernehmen',
    imports: [
    TranslatePipe
  ],
    templateUrl: './bestellung-uebernehmen-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./bestellung-uebernehmen-dialog.component.css']
})
export class BestellungUebernehmenDialogComponent implements Modal<boolean> {
  close!: (result: boolean) => void;
  registerCloseHandler(handler: (result: boolean) => void): void {
    this.close = handler;
  }
}
